module.exports = {
  resultList: [
    {
      content: '【IP资讯】传递开放自信　真诚赢得赞誉——国家知识产权局开放日活动侧记',
      time: '2019-4-11',
      id: 1
    },
    {
      content: '首批中级国际技术转移经理人在穗完成培训',
      time: '2019-4-11',
      id: 5
    },
    {
      content: '首批中级国际技术转移经理人在穗完成培训',
      id: 4,
      time: '2019-4-11'
    },
    {
      content: '首批中级国际技术转移经理人在穗完成培训',
      id: 3,
      time: '2019-4-11'
    },
    {
      content: '首批中级国际技术转移经理人在穗完成培训',
      id: 66,
      time: '2019-4-11'
    },
    {
      content: '首批中级国际技术转移经理人在穗完成培训',
      id: 77,
      time: '2019-4-11'
    },
    {
      content: '首批中级国际技术转移经理人在穗完成培训',
      id: 13,
      time: '2019-4-11'
    },
    {
      content: '【IP资讯】传递开放自信　真诚赢得赞誉——国家知识产权局开放日活动侧记',
      id: 2,
      time: '2019-4-11'
    }
  ],
  sideList: [
    { content: '市市场监管局迅速开展安全生产大检查' },
    { content: '全力筑牢安全生产防线' },
    { content: '市市场监管局迅速开展安全生产大检查' },
    { content: '全力筑牢安全生产防线' },
    { content: '全力筑牢安全生产防线' }
  ]
}